var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbnormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4004_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4812 6.0002C31.5356 5.98417 33.3815 6.92456 34.6153 8.52483C41.9585 20.7272 49.3461 32.9175 56.5076 45.2214C56.6328 45.6863 56.9099 46.2767 56.9624 46.7429C57.0095 47.161 57.0149 48.1441 56.9624 48.5555C56.6287 51.1577 54.0402 53.697 51.4045 53.9655C44.0977 54.0189 36.7881 53.9962 29.4812 53.9949L29.266 53.896V46.1231L29.4812 45.9962C29.4906 45.9134 29.5175 45.7878 29.5767 45.7825C29.9454 45.7517 32.3415 45.717 32.5474 45.7825L32.7021 45.9962C32.6174 45.9868 32.4895 45.9561 32.4868 45.8973C32.4196 43.919 32.4196 41.7057 32.4868 39.726L32.7021 39.5978C32.6927 39.6806 32.6658 39.8075 32.6066 39.8115C31.755 39.8703 30.4876 39.8703 29.6359 39.8115L29.4812 39.5978C29.3978 39.5884 29.2713 39.5617 29.266 39.503C29.235 39.137 29.2 36.7566 29.266 36.5509L29.4812 36.3973C29.4906 36.3144 29.5162 36.1916 29.5767 36.1835C30.1391 36.1127 31.9931 36.1061 32.5474 36.1835L32.7021 36.3973L32.4868 36.3225V20.5308L32.7021 20.3986C32.6927 20.4814 32.6658 20.6083 32.6066 20.6123C31.755 20.6711 30.4876 20.6711 29.6359 20.6123L29.4812 20.3986L29.266 20.3251V6.13111L29.4812 6.0002Z",
    fill: "#FCBE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4817 6V20.3984C29.4709 20.4812 29.4494 20.6001 29.3862 20.6121C28.9018 20.6989 26.9537 20.6682 26.4155 20.6121L26.2608 20.3984L26.4761 20.4732V36.2648L26.2608 36.3971C26.2702 36.3142 26.2958 36.1914 26.3563 36.1833C26.9187 36.1125 28.7727 36.1059 29.327 36.1833L29.4817 36.3971V39.5963C29.4723 39.6791 29.4467 39.802 29.3862 39.81C28.8238 39.8781 26.9617 39.8888 26.4155 39.81L26.2608 39.5963L26.4761 39.6951V45.8664L26.2608 45.9947C26.2702 45.9118 26.2971 45.7863 26.3563 45.7809C26.7249 45.7502 29.1211 45.7155 29.327 45.7809L29.4817 45.9947V53.9933C22.343 53.9933 15.2016 53.9893 8.0602 53.9987C3.31497 53.6687 0.497698 48.5781 2.84004 44.4305L24.4391 8.40174C25.7253 6.8883 27.4676 6.01603 29.4817 6Z",
    fill: "#FED300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4809 20.3984H32.7018V36.3971H29.4809L29.2656 36.3223V20.5307L29.4809 20.3984Z",
    fill: "#3E5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4806 39.5967H32.7015V45.9964H29.4806C29.3958 45.9871 29.268 45.9563 29.2653 45.8976C29.198 43.9193 29.198 41.7059 29.2653 39.7263L29.4806 39.598V39.5967Z",
    fill: "#3E5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4807 20.3984H26.2598V36.3971H29.4807V20.3984Z",
    fill: "#4A696F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4807 39.5967H26.2598V45.9964H29.4807V39.5967Z",
    fill: "#4A696F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4004_160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 48,
    fill: "white",
    transform: "translate(2 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbnormal);
export default __webpack_public_path__ + "static/media/abnormal.125c1df72100cc1ced56b8210df455cf.svg";
export { ForwardRef as ReactComponent };